import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidatorService } from 'app/shared/services/validator.service';
import { ISelect } from 'app/shared/models/select.model';
import { IAppearance } from 'app/shared/models/recruitment/appearance.model';
import { Subject } from 'rxjs';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-modal-appearance',
  templateUrl: './modal-appearance.template.html',
  encapsulation: ViewEncapsulation.None
})

export class ModalAppearanceComponet implements OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [true];
  private errorMessages: any;
  /**Catalogos */
  private catalogSizes: ISelect[];
  private catalogPhysicalComplexion: ISelect[];
  private catalogShirtSizes: ISelect[];
  private catalogStatures: ISelect[];
  private catalogShoeSizes: ISelect[];
  private listCatalogs = new Array() as Array<ISelect[]>;
  private appearance: IAppearance;
  private module: string;
  private action: string;
  /**Formularios */
  private formAppearance: FormGroup;
  /**Retorno a pantalla padre */
  public onClose: Subject<IAppearance>;
  /**Notificaciones */
  private configToast: any;
  employeeId: number;
  constructor(private bsModalRef: BsModalRef
    , private recruitmentService: RecruitmentService
    , private formBuilder: FormBuilder
    , private configGeneral: AppConfig
    , public snotifyService: SnotifyService
    , private spinner: NgxSpinnerService) {
    this.initializeFormAppearance();
    this.configToast = configGeneral.getConfigToast();
  }
  ngOnInit(): void {
    this.catalogSizes = this.listCatalogs[0];
    this.catalogPhysicalComplexion = this.listCatalogs[1];
    this.catalogStatures = this.listCatalogs[2];
    this.catalogShoeSizes = this.listCatalogs[3];
    this.catalogShirtSizes = this.listCatalogs[4];
    this.onClose = new Subject();
    if (this.appearance != null || this.appearance != undefined) {
      this.setAppearance();
    }
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
  private initializeFormAppearance() {
    this.formAppearance = this.formBuilder.group({
      size: [null, Validators.required],
      physicalComplexion: [null, Validators.required],
      stature: [null, Validators.required],
      shoeSizeId: [null, Validators.required],
      shirtSizeId: [null, Validators.required]
    });
  }
  public getError(controlName: string): any {
    let error = '';
    let obj = {} as any;
    const control = this.formAppearance.get(controlName);
    if (control.errors != null) {
      error = JSON.stringify(control.errors);
      obj = JSON.parse(error);
    }
    return obj;
  }
  save(): void {
    if (this.formAppearance.valid) {
      let isNullAppearance = this.appearance == null ? true : false;
      if (this.module == 'employee' || this.module == 'dashboard') {
        if (this.appearance == null) {
          this.appearance = {} as IAppearance;
          this.appearance.jobCandidateId = this.employeeId;
        }
        this.appearance.shirtSizeId = this.formAppearance.value.shirtSizeId;
        this.appearance.sizeId = this.formAppearance.value.size;
        this.appearance.physicalComplexionId = this.formAppearance.value.physicalComplexion;
        this.appearance.statureId = this.formAppearance.value.stature;
        this.appearance.shoeSizeId = this.formAppearance.value.shoeSizeId;
        this.spinner.show();
        if (this.module == 'dashboard' && isNullAppearance) {
          this.recruitmentService.addJobCandidateAppearance(this.appearance)
            .subscribe(
              (x) => {
                this.configGeneral.notificationSuccessError(x)
                this.spinner.hide();
                this.bsModalRef.hide();
              },
              (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
              });
        } else {
          this.recruitmentService.updateJobCandidateAppearance(this.appearance)
            .subscribe(
              (x) => {
                this.configGeneral.notificationSuccessError(x)
                this.spinner.hide();
                this.bsModalRef.hide();
              },
              (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
              });
        }
      } else {
        this.appearance = this.mapAppearance(this.formAppearance.value);
        this.onClose.next(this.appearance);
        this.bsModalRef.hide();
      }
    } else {
      this.snotifyService.error('Capture toda la información requerida para poder continuar'
        , 'Validación', this.configToast);
    }
  }
  private setAppearance(): void {
    this.formAppearance.get('size').setValue(this.appearance.sizeId.toString());
    this.formAppearance.get('physicalComplexion').setValue(this.appearance.physicalComplexionId.toString());
    this.formAppearance.get('stature').setValue(this.appearance.statureId.toString());
    this.formAppearance.get('shoeSizeId').setValue(this.appearance.shoeSizeId.toString());
    this.formAppearance.get('shirtSizeId').setValue(this.appearance.shirtSizeId);
  }
  private mapAppearance(form: any): IAppearance {
    const data = {} as IAppearance;
    data.sizeId = form.size;
    data.physicalComplexionId = form.physicalComplexion;
    data.statureId = form.stature;
    data.shoeSizeId = form.shoeSizeId;
    data.shirtSizeId = form.shirtSizeId;
    return data;
  }
}
